/* eslint-disable */
import { configureStore } from '@reduxjs/toolkit'
import reducers from './reducers'

export const appStore = configureStore({
  reducer: reducers,
  middleware(getDefaultMiddleware) {
    if (process.env.NODE_ENV === 'development') {
      return getDefaultMiddleware().concat(require('redux-logger').default)
    }

    return getDefaultMiddleware().concat()
  }
})
